module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Jums reikalinga elektrinės galia","text":"Tinkamos galios elektrinė garantuos efektyvų energijos generavimą. Vidutiniškai 1 kW pagamina 1000 kWh/metus. Jeigu Jūsų namų ūkis per metus suvartoja 8000 kWh, Jums reikalinga maždaug 8 kW galios elektrinė.","legends":["1 kW iki 7 m2 - ant šlaitinio stogo","1 kW nuo 12 m2 - ant plokščio stogo"]}}')
  delete Component.options._Ctor
}
